import { connect } from 'react-redux';
import DaEditorWrapper from './DaEditorWrapper';
import { mentionSearchChange } from './AsyncHandlers/Mentions/actionCreators';
import { findPastedDeviation } from './AsyncHandlers/DeviationPaste/actionCreators';
import { markEditorFocused, markEditorInactive } from './redux/actionCreators';
import { getFlags } from '../redux/flags/selectors';
var mapStateToProps = function (state, props) { return ({
    featureFlags: getFlags(state),
}); };
var mapDispatchToProps = {
    mentionSearchChange: mentionSearchChange,
    findPastedDeviation: findPastedDeviation,
    editorFocused: markEditorFocused,
    editorBlurred: markEditorInactive,
};
export default connect(mapStateToProps, mapDispatchToProps)(DaEditorWrapper);
//# sourceMappingURL=DaEditorWrapper.container.js.map